// STEP 1 - Include Dependencies
// Include react
import React from "react";
import ReactDOM from "react-dom";

// Include the react-fusioncharts component
import ReactFC from "react-fusioncharts";

// Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Include the chart type
import Column2D from "fusioncharts/fusioncharts.charts";

// Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

// STEP 2 - Chart Data
function PieChartDistributor(props) {
  //console.log("PIE CHART DIST", props);
  // let chartData = [];
  let colors = [
    // "#FFF8E6",
    "#BBBBBB",
    "#3081B4",
    "#717171",
    "#333333",
    "#89C4F4",
      
  ];
  let rows = [];
  Object.keys(props.aumWiseData).map((key, index) => {
    rows.push({
      key: key,
      label: props.aumWiseData[key]["investorName"],
      value: props.aumWiseData[key]["aum"],
      color: colors[index],
    });
  });

  let chartData = rows;
  //console.log("chartData in pie", chartData);

  const chartConfigs = {
    type: "pie2d", // The chart type
    width: "300", // Width of the chart
    height: "210", // Height of the chart
    dataFormat: "json", // Data type
    dataSource: {
      // Chart Configuration
      chart: {
        doughnutRadius: "65%",
        //subcaption: "For all users in 2017",
        showpercentvalues: "1",
        // defaultcenterlabel:
        //   "₹" +
        //   props.cat2.cat2Data.categoryWiseTotal.category2.currentValue.toString(),
        aligncaptionwithcanvas: "0",
        captionpadding: "0",
        enableSlicing: "0",
        legendNumColumns: "2",
        enableRotation: "0",
        decimals: "1",
        showlabels: "0",
        showValues: "0",
        plottooltext: "<b>$percentValue</b> <b>$label</b>",
        centerlabel: "# Invested Value: $value",
        theme: "fusion",
        showLegend: "0",
        // legendNumRows: "2",
        legendItemFontSize: "12",
        chartLeftMargin: "0",
        chartTopMargin: "0",
        chartRightMargin: "0",
        chartBottomMargin: "0",
      },
      // Chart Data
      data: chartData,
    },
  };

  return <ReactFC {...chartConfigs} />;
}

export default PieChartDistributor;
